import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getAcao, cadastrarAcao, alterarAcao, excluirAcao } from '../../../api';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
var AcoesEditar = function () {
    var services = {
        getItem: getAcao,
        cadastrarItem: cadastrarAcao,
        alterarItem: alterarAcao,
        excluirItem: excluirAcao,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.ACOES, paginaPermissao: FUNCIONALIDADES.ACOES, rota: ROUTES.ACOES, services: services });
};
export default AcoesEditar;
